<template>
  <v-footer
    class="white--text"
    color="third"
  >
    <v-row
      align="center"
      justify="start"
    >
      <v-col
        class="text-center"
        cols="12"
        sm="2"
      >
        <figure class="d-flex align-right md4">
          <img
            class="b-footer__logo mx-auto align-center"
            :src="retornarParametrosGenerales && retornarParametrosGenerales.urlLgf ? retornarParametrosGenerales.urlLgf : '../../../img/logo-blanco.png'"
            :alt="$t('logo_alt')"
          >
        </figure>
      </v-col>
      <v-col
        cols="12"
        sm="9"
        class="b-footer text-center text-sm-right"
      >
        <i18n
          path="copy_right"
          tag="span"
        >
          <span
            class="inline-flex"
            place="copy"
          >
            <v-icon
              class="white--text"
              small
            >fal fa-copyright</v-icon>
            {{ currentYear }}
          </span>
        </i18n>
        <figure class="d-inline-block">
          <img
            class="ml-1 b-footer__designed"
            src="../../../public/img/logo-cadena-apps.png"
            :alt="$t('logo_footer_alt')"
          >
        </figure>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

/**
   * Component that represent the application footer.
   *
    * @returns {number}
    *
    * @author Valentín Agudelo
    * @since 19/02/2020 11:05 AM
    */
export default {
  name: 'TheFooter',
  computed: {
    ...mapGetters([
      'retornarParametrosGenerales'
    ]),
    /**
       * Obtener el año actual.
       *
       * @returns {number}
       *
       * @author Valentín Agudelo
       * @since 19/02/2020 11:05 AM
       * @version 1.0.0
       */
    currentYear () {
      return moment().year()
    }
  }
}
</script>
<style lang="scss" scoped>
.b-footer {
  font-size: 10pt !important;
  &__logo {
    max-width: 20rem;
  }
  &__designed {
    width: 9.5em;
  }
}
</style>
<i18n>
{
  "es": {
    "logo_alt": "Logo Footer",
    "copy_right": "Copyright {copy} Fundación Organización VID - Desarrollado por ",
    "designed": "Designed by ",
    "logo_footer_alt": "Logo Cadena Apps"
  }
}
</i18n>
